import { getCareerYear } from '../../../utils/date';

const COLOR_A = '#D75428';
const COLOR_B = '#2857D7';

export const ComparisonResult = ({ targetA, targetB }) => {
  const careerA = getCareerYear(targetA.startYear);
  const careerB = getCareerYear(targetB.startYear);
  const diff = Math.abs(careerA - careerB);
  const longer = careerA >= careerB ? targetA : targetB;
  const color = diff === 0 ? '#222' : longer === targetA ? COLOR_A : COLOR_B;

  return (
    <div
      style={{
        background: '#fff',
        borderRadius: 16,
        padding: '20px 24px',
        textAlign: 'center',
        border: `2px solid ${color}`,
        boxShadow: `0 2px 10px ${color}26`,
      }}
    >
      <p style={{ margin: '0 0 4px', fontSize: 11, color, fontWeight: 'bold', letterSpacing: '0.15em' }}>
        RESULT
      </p>
      {diff === 0 ? (
        <>
          <p style={{ margin: '0 0 2px', fontSize: 15, color: '#555' }}>芸歴は同じ</p>
          <p style={{ margin: 0, fontSize: 36, fontWeight: 'bold', color, lineHeight: 1 }}>
            {careerA}<span style={{ fontSize: 18, fontWeight: 'normal' }}>年</span>
          </p>
        </>
      ) : (
        <>
          <p style={{ margin: '0 0 6px', fontSize: 18, fontWeight: 'bold', color }}>
            {longer.name}
          </p>
          <p style={{ margin: 0, fontSize: 14, color: '#555' }}>
            の方が芸歴が
            <span style={{ fontSize: 36, fontWeight: 'bold', display: 'inline-block', margin: '0 4px', lineHeight: 1, color }}>
              {diff}
            </span>
            年長い
          </p>
        </>
      )}
    </div>
  );
};
